import React, { useRef, useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import { Breadcrumb as AntBreadcrumb, Select } from 'antd'
import * as _ from 'lodash';
import { ThemeProvider, Icon } from 'dlweb-components';

const Breadcrumb = ({ paths, disableLink, $location, $rootScope, onClick }) => {

  const [overflowPaths, setOverflowPaths] = useState([]);
  const [breadcrumbPaths, setBreadcrumbPaths] = useState([]);
  const [widths, setWidths] = useState({})

  const breadcrumbRef = useRef(null);
  const { Option } = Select;
  
  const insert = (arr, index, ...newItems) => [
    ...arr.slice(0, index),
    ...newItems,
    ...arr.slice(index)
  ]

  const onResize = () => {
    if(breadcrumbRef.current) {
      const visibleWidth = breadcrumbRef.current.getBoundingClientRect().width;
      const breadcrumbWidth = breadcrumbRef.current.children[0].offsetWidth;

      if (breadcrumbWidth > 0) {
        setWidths({ visibleWidth, breadcrumbWidth });
      }
    }
  }

  function itemRender(route, params, routes, paths) {

    const last = routes.indexOf(route) === routes.length - 1;

    if(last || disableLink) {
      if(route.routeCollection) {
        return (
          <Select
            defaultValue={$location.url()}
            style={{ width: 200, marginTop: '-5px' }}
            onSelect={(path) => { $rootScope.$apply(() => $location.url(path)); }}
          >
            {route.routeCollection.map((r, i) => (
              <Option key={i} value={r.path}>
                {r.name}
              </Option>
            ))}
          </Select>
        )
      }
      else {
        return <div className="breadcrumb-item" data-id={route.pathId} data-name={route.breadcrumbName}>
                <span>{route.breadcrumbName}</span>
                </div>
      }
     }
     else {
        return <div className='breadcrumb-item' data-id={route.pathId} data-name={route.breadcrumbName}>
                  {_.isFunction(onClick) &&
                      <a href="#0" onClick={(e) => { e.preventDefault(); onClick(route);}}>{route.breadcrumbName}</a>
                  }
                  {!_.isFunction(onClick) &&
                    <a href={route.path}>{route.breadcrumbName}</a>
                  }
                </div>
     }
  }

  // handle window resize
  useEffect(() => {

    const { visibleWidth, breadcrumbWidth } = widths;

    if (visibleWidth > breadcrumbWidth) {

      setOverflowPaths(prevOverflowPaths => {
        
        if (prevOverflowPaths.length === 0) return [];

        let i = 0;
        let addedPaths = [];
        let newBreadcrumbWidth = breadcrumbWidth;

        do {

          // remove overflowPath and save element width
          let addedPath = prevOverflowPaths[i];

          // add width to breadcrumb length
          newBreadcrumbWidth += addedPath.width;

          // make sure we're not adding too much size with the new element
          if (newBreadcrumbWidth > visibleWidth - 50) break;

          addedPaths.push(addedPath)

          i++;

        } while (newBreadcrumbWidth < visibleWidth && i < prevOverflowPaths.length)

        // add path to array
        const newOverflowPaths = _.filter(prevOverflowPaths, o => { return !_.includes(_.map(addedPaths, 'path'), o.path) });
        
        setBreadcrumbPaths(prevBreadcrumbPaths => {

          if (addedPaths.length === 0) return prevBreadcrumbPaths;

          // copy breadcrumbs
          let breadcrumbCopy = _.cloneDeep(prevBreadcrumbPaths);
          delete breadcrumbCopy[breadcrumbCopy.length - 2].menu;
          
          if (newOverflowPaths.length > 0) {
            breadcrumbCopy.splice(prevBreadcrumbPaths.length - 1, 0, ...addedPaths)
            breadcrumbCopy[breadcrumbCopy.length - 2].menu = {
              items: newOverflowPaths.map(o => {
                return {
                  key: o.pathId, 
                  label: o.breadcrumbName,
                  onClick: () => { $location.url(o.path); $rootScope.$apply(); }
                }
              }
            )};

            return breadcrumbCopy;
          }
          else {
            return insert(breadcrumbCopy, breadcrumbCopy.length - 1, ...addedPaths);
          }
        })

        if (addedPaths.length === 0) return prevOverflowPaths;

        return newOverflowPaths;
      })
    }

    if (visibleWidth - 50 < breadcrumbWidth) {

      setBreadcrumbPaths(prevBreadcrumbPaths => {

        let i = 1;
        let removedPaths = [];
        let newBreadcrumbWidth = breadcrumbWidth;

        do {

          const ol = breadcrumbRef.current.children[0].children[0];
          const li = ol.querySelectorAll(`li:not(.ant-breadcrumb-separator)`);

          // get width of the element we're removing - minimum width is 50px
          const elementWidth = Math.max(li[li.length - i].getBoundingClientRect().width, 50);
          
          newBreadcrumbWidth -= elementWidth;

          // create overflowPath and save element width
          let removedPath = { width: elementWidth, ...prevBreadcrumbPaths[prevBreadcrumbPaths.length - 1 - i] }

          delete removedPath.menu;
          removedPaths.unshift(removedPath);        

          i++;

        } while (visibleWidth - 25 < newBreadcrumbWidth)

        // remove paths from array
        let pathsCopy = _.filter(prevBreadcrumbPaths, o => { return !_.includes(_.map(removedPaths, 'path'), o.path) });

        setOverflowPaths(prevPaths => {
          const newOverflowPaths = [...removedPaths, ...prevPaths];

          pathsCopy[pathsCopy.length - 2].menu = {
            items: newOverflowPaths.map(o => {
              return {
                key: o.pathId, 
                label: o.breadcrumbName,
                onClick: () => { $location.url(o.path); $rootScope.$apply(); }
              }
            }
          )};

          return newOverflowPaths;
        });

        return pathsCopy;
      })
    }
  }, [onClick, widths])

  useEffect(() => {
    if(paths) {
      setOverflowPaths([]);
      setBreadcrumbPaths(_.cloneDeep(paths));

      setTimeout(() => {
        onResize();
      })
    }
  }, [paths])

  useEffect(() => {
    window.addEventListener('resize', _.debounce(onResize, 150));
    return () => window.removeEventListener('resize', _.debounce(onResize, 150));
  }, [])

  return (
    <ThemeProvider>
      <BreadcrumbContainer ref={breadcrumbRef} id="wt-breadcrumb-wrapper">
        <AntBreadcrumb
          separator={<Icon type="angle-right" style={{margin: '1px 5px 0 5px'}}/>}
          items={breadcrumbPaths}
          itemRender={itemRender}
          style={{ display: "inline-block", fontSize: "16px", overflow: "hidden", textOverflow: "ellipsis" }}
        />
      </BreadcrumbContainer>
    </ThemeProvider>
  );
}

const BreadcrumbContainer = styled.div`
  height: 51px; //add pixel for bottom border
  width: 100%;
  padding: 0 10px;
  white-space: nowrap;
  background-color: #fff;
  border-bottom: 1px solid #dee0e3;
  user-select: none;
  .ant-breadcrumb ol {
    height: 50px;
    flex-wrap: nowrap;
    align-items: center;
  }
  .ant-breadcrumb-overlay-link {
    height: 50px;
    display: flex;
    :hover {
      background-color: #fff;
    }
  }
  .ant-breadcrumb-overlay-link > .anticon-down {
    margin-top: 2px;
  }
`

export default React.memo(Breadcrumb);